import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import _ from "lodash";
import { EditActions, editActions } from "../../../actions/editActions";
import { isEditActiveSelector } from "../../../reducers/editReducer";
import EditAADGroup from "../../Editing/EditAADGroup";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
};

type DispatchProps = {
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.UserSubmenu;
  toggleModal: () => void;
  setColumnFilters: (subMenuRoute: State.AnySubMenu | State.AnyChildItem, columnFilter: Filter[]) => void;
};

// Props of the component
export type AADGroupsTableProps = StateProps & DispatchProps & OwnProps;

type AADGroupsTableState = {
  isModalOpen: boolean;
};

export class AADGroupsTable extends React.Component<AADGroupsTableProps, AADGroupsTableState> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal } = this.props;
    const { aadgroups } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let selectedColumns: State.Column[] = [];

    const rows: Api.AADGroup[] = [...aadgroups];
    selectedColumns = columns.AADGroups;

    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            rows={rows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isAADGroupSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}            
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditAADGroup toggleModal={toggleModal} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  private isAADGroupSelected = (parameter: Api.AnyParameter): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && parameter.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView)
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AADGroupsTable);
